import { useMemo, useState, Children, PropsWithChildren } from "react";

type ExpandibleListProps = PropsWithChildren<{
  limit: number;
  showCount?: boolean;
  itemsName: string;
  printable?: boolean;
}>;

export function ExpandibleList({ limit, showCount, itemsName, printable = false, children }: ExpandibleListProps) {
  const [expanded, setExpanded] = useState(false);

  const length = Children.count(children);
  const showExpandButton = length > limit;

  const visiblechildren = useMemo(
    () => Children.toArray(children).slice(0, expanded ? Infinity : limit),
    [children, expanded, limit]
  );

  return (
    <div className="flex flex-col overflow-hidden border divide-y rounded-sm divide-neutral-200 border-neutral-300">
      {visiblechildren}
      {showExpandButton && !printable && (
        <button
          className="p-2 text-xs border-solid bg-neutral-50 hover:bg-neutral-100 text-text-base-active hover:text-text-base-active-hover"
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? `Show fewer ${itemsName}` : `Show all ${showCount ? `${length} ` : ""}${itemsName}`}
        </button>
      )}
    </div>
  );
}
